import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import PaymentSetupServices from "./PaymentSetupServices";
import { toast } from "react-toastify";
import { successAlert } from "../../Global/GlobalSlice";

export const getPaymentRequest = createAsyncThunk(
  "paymentSetup/getPaymentRequest",
  async (data, { rejectWithValue, getState, dispatch }) => {
    sessionStorage.setItem("sessionTable", JSON.stringify(true));
    try {
      const responseData = await PaymentSetupServices.getPaymentRequest(data);

      // if (responseData?.successful === true) {
      //   toast.success(responseData?.statusMessage);
      // }

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getAllContainer = createAsyncThunk(
  "paymentSetup/getAllContainer",
  async (_, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PaymentSetupServices.getAllContainer();

      // if (responseData?.successful === true) {
      //   toast.success(responseData?.statusMessage);
      // }

      // console.log({ responseData });

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const deletePaymentRequest = createAsyncThunk(
  "paymentSetup/deletePaymentRequest",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PaymentSetupServices.deletePaymentRequest(
        payload
      );

      if (responseData?.successful === true) {
        toast.success(responseData?.statusMessage);
      } else {
        toast.success(responseData?.statusMessage);
      }

      // console.log({ responseData });

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const approveNarration = createAsyncThunk(
  "paymentSetup/approveNarration",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PaymentSetupServices.approveNarration(data);

      if (responseData?.successful === true) {
        toast.success(responseData?.statusMessage);
      } else {
        toast.success(responseData?.statusMessage);
      }

      // console.log({ responseData });

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const approvePaymentType = createAsyncThunk(
  "paymentSetup/approvePaymentType",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PaymentSetupServices.approvePaymentType(data);

      if (responseData?.successful === true) {
        toast.success(responseData?.statusMessage);
      } else {
        toast.success(responseData?.statusMessage);
      }

      // console.log({ responseData });

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const approvePaymentRecognitionSetup = createAsyncThunk(
  "paymentSetup/approvePaymentRecognitionSetup",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData =
        await PaymentSetupServices.approvePaymentRecognitionSetup(data);

      // if (responseData?.successful === true) {
      //   toast.success(responseData?.statusMessage);
      // } else {
      //   toast.success(responseData?.statusMessage);
      // }

      // console.log({ responseData });

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const declinePaymentRecognitionSetup = createAsyncThunk(
  "paymentSetup/declinePaymentRecognitionSetup",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData =
        await PaymentSetupServices.declinePaymentRecognitionSetup(data);

      // if (responseData?.successful === true) {
      //   toast.success(responseData?.statusMessage);
      // } else {
      //   toast.success(responseData?.statusMessage);
      // }

      // console.log({ responseData });

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const declineWitholdingTaxSetup = createAsyncThunk(
  "paymentSetup/declineWitholdingTaxSetup",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PaymentSetupServices.declineWitholdingTaxSetup(
        data
      );

      // if (responseData?.successful === true) {
      //   toast.success(responseData?.statusMessage);
      // } else {
      //   toast.success(responseData?.statusMessage);
      // }

      // console.log({ responseData });

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const approveWitholdingTaxSetup = createAsyncThunk(
  "paymentSetup/approveWitholdingTaxSetup",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PaymentSetupServices.approveWitholdingTaxSetup(
        data
      );

      // if (responseData?.successful === true) {
      //   toast.success(responseData?.statusMessage);
      // } else {
      //   toast.success(responseData?.statusMessage);
      // }

      // console.log({ responseData });

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updatePaymentRecognitionSetup = createAsyncThunk(
  "paymentSetup/updatePaymentRecognitionSetup",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData =
        await PaymentSetupServices.updatePaymentRecognitionSetup(data);

      // if (responseData?.successful === true) {
      //   toast.success(responseData?.statusMessage);
      // } else {
      //   toast.success(responseData?.statusMessage);
      // }

      // console.log({ responseData });

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updateWitholdingTaxSetup = createAsyncThunk(
  "paymentSetup/updateWitholdingTaxSetup",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PaymentSetupServices.updateWitholdingTaxSetup(
        data
      );

      // if (responseData?.successful === true) {
      //   toast.success(responseData?.statusMessage);
      // } else {
      //   toast.success(responseData?.statusMessage);
      // }

      // console.log({ responseData });

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// deletePaymentRecognitionSetup
export const deletePaymentRecognitionSetup = createAsyncThunk(
  "paymentSetup/deletePaymentRecognitionSetup",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData =
        await PaymentSetupServices.deletePaymentRecognitionSetup(data);

      // if (responseData?.successful === true) {
      //   toast.success(responseData?.statusMessage);
      // } else {
      //   toast.success(responseData?.statusMessage);
      // }

      // console.log({ responseData });

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const declinePaymentType = createAsyncThunk(
  "paymentSetup/declinePaymentType",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PaymentSetupServices.declinePaymentType(data);

      if (responseData?.successful === true) {
        toast.success(responseData?.statusMessage);
      } else {
        toast.success(responseData?.statusMessage);
      }

      // console.log({ responseData });

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const declineNarration = createAsyncThunk(
  "paymentSetup/declineNarration",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PaymentSetupServices.declineNarration(data);

      if (responseData?.successful === true) {
        toast.success(responseData?.statusMessage);
      } else {
        toast.success(responseData?.statusMessage);
      }

      // console.log({ responseData });

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getPaymentNarrations = createAsyncThunk(
  "paymentSetup/getPaymentNarrations",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PaymentSetupServices.getPaymentNarrations(
        data
      );

      // if (responseData?.successful === true) {
      //   toast.success(responseData?.statusMessage);
      // }

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getAllEmployees = createAsyncThunk(
  "paymentSetup/getAllEmployees",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PaymentSetupServices.getAllEmployees(data);

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getAllDepts = createAsyncThunk(
  "paymentSetup/getAllDepts",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PaymentSetupServices.getAllDepts(data);

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getPaymentType = createAsyncThunk(
  "paymentSetup/getPaymentType",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PaymentSetupServices.getPaymentType(data);

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const createPaymentRecognitionSetup = createAsyncThunk(
  "paymentSetup/createPaymentRecognitionSetup",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData =
        await PaymentSetupServices.createPaymentRecognitionSetup(data);

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const createExchangeRateSetup = createAsyncThunk(
  "paymentSetup/createExchangeRateSetup",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PaymentSetupServices.createExchangeRateSetup(
        data
      );

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updateExchangeRateSetup = createAsyncThunk(
  "paymentSetup/updateExchangeRateSetup",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PaymentSetupServices.updateExchangeRateSetup(
        data
      );

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getExchangeRateSetup = createAsyncThunk(
  "paymentSetup/getExchangeRateSetup",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PaymentSetupServices.getExchangeRateSetup(
        data
      );

      return responseData;
    } catch (error) {
      console.log({ error });

      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getWitholdingTaxSetup = createAsyncThunk(
  "paymentSetup/getWitholdingTaxSetup",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PaymentSetupServices.getWitholdingTaxSetup(
        data
      );

      return responseData;
    } catch (error) {
      console.log({ error });

      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getWitholdingTaxSetupId = createAsyncThunk(
  "paymentSetup/getWitholdingTaxSetupId",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PaymentSetupServices.getWitholdingTaxSetupId(
        data
      );

      return responseData;
    } catch (error) {
      console.log({ error });

      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getPaymentRecognitionSetup = createAsyncThunk(
  "paymentSetup/getPaymentRecognitionSetup",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData =
        await PaymentSetupServices.getPaymentRecognitionSetup(data);

      return responseData;
    } catch (error) {
      console.log({ error });

      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getAccountLedgerSetup = createAsyncThunk(
  "paymentSetup/getAccountLedgerSetup",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PaymentSetupServices.getAccountLedgerSetup(
        data
      );

      return responseData;
    } catch (error) {
      console.log({ error });

      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const createPaymentWitholdingTaxSetup = createAsyncThunk(
  "paymentSetup/createPaymentWitholdingTaxSetup",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData =
        await PaymentSetupServices.createPaymentWitholdingTaxSetup(data);

      return responseData;
    } catch (error) {
      console.log({ error });

      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getFeeSetup = createAsyncThunk(
  "paymentSetup/getFeeSetup",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PaymentSetupServices.getFeeSetup(data);

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const createPaymentType = createAsyncThunk(
  "paymentSetup/createPaymentType",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PaymentSetupServices.createPaymentType(data);

      if (responseData?.successful === true) {
        toast.success(responseData?.statusMessage);
      } else {
        toast.error(responseData?.statusMessage);
      }

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updatePaymentType = createAsyncThunk(
  "paymentSetup/updatePaymentType",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PaymentSetupServices.updatePaymentType(data);

      if (responseData?.successful === true) {
        toast.success(responseData?.statusMessage);
      } else {
        toast.error(responseData?.statusMessage);
      }

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const createPayment = createAsyncThunk(
  "paymentSetup/createPayment",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PaymentSetupServices.createPayment(data);

      if (responseData?.successful === true) {
        toast.success(responseData?.statusMessage);
      } else {
        toast.error(responseData?.statusMessage);
      }

      // console.log({ responseData });

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const createNarration = createAsyncThunk(
  "paymentSetup/createNarration",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PaymentSetupServices.createNarration(data);

      if (responseData?.successful === true) {
        toast.success(responseData?.statusMessage);
      } else {
        toast.error(responseData?.statusMessage);
      }

      console.log({ responseData });

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error("Unable to create narration, possible duplicate...");
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const editNarration = createAsyncThunk(
  "paymentSetup/editNarration",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PaymentSetupServices.editNarration(data);

      if (responseData?.successful === true) {
        toast.success(responseData?.statusMessage);
      } else {
        toast.error(responseData?.statusMessage);
      }

      console.log({ responseData });

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updatePayment = createAsyncThunk(
  "paymentSetup/updatePayment",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PaymentSetupServices.updatePayment(data);

      if (responseData?.successful === true) {
        toast.success(responseData?.statusMessage);
      } else {
        toast.error(responseData?.statusMessage);
      }

      console.log({ responseData });

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

const initialState = {
  isLoading: false,
  error: null,
  setupData: {},
  narrationData: {},
  employees: [],
  depts: [],
  paymentTypes: [],
  container: [],
  FeeSetup: [],
  witholdingTaxSetup: [],
  accountLedgerSetup: [],
  paymentRecognitionSetup: [],
  witholdingTaxSetupDetails: {},
};

const reducers = {
  viewSetup(state, action) {
    return { ...state, data: action.payload };
  },
};

export const PaymentSetupSlice = createSlice({
  name: "paymentSetup",
  initialState,
  reducers,
  extraReducers: (builder) => {
    builder
      .addCase(getPaymentRequest.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(getPaymentRequest.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          setupData: action.payload,
        };
      })
      .addCase(getPaymentRequest.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
    builder
      .addCase(getAllContainer.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(getAllContainer.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          container: action.payload,
        };
      })
      .addCase(getAllContainer.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
    builder
      .addCase(deletePaymentRequest.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(deletePaymentRequest.fulfilled, (state) => {
        return {
          ...state,
          isLoading: false,
        };
      })
      .addCase(deletePaymentRequest.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
    builder
      .addCase(createNarration.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(createNarration.fulfilled, (state) => {
        return {
          ...state,
          isLoading: false,
        };
      })
      .addCase(createNarration.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
    builder
      .addCase(approveNarration.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(approveNarration.fulfilled, (state) => {
        return {
          ...state,
          isLoading: false,
        };
      })
      .addCase(approveNarration.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
    builder
      .addCase(declineNarration.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(declineNarration.fulfilled, (state) => {
        return {
          ...state,
          isLoading: false,
        };
      })
      .addCase(declineNarration.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
    builder
      .addCase(getPaymentNarrations.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(getPaymentNarrations.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          narrationData: action.payload,
        };
      })
      .addCase(getPaymentNarrations.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
    builder
      .addCase(getPaymentType.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(getPaymentType.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          paymentTypes: action.payload,
        };
      })
      .addCase(getPaymentType.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });

    builder
      .addCase(getExchangeRateSetup.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(getExchangeRateSetup.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          exchangeRates: action.payload,
        };
      })
      .addCase(getExchangeRateSetup.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });

    builder
      .addCase(getWitholdingTaxSetup.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(getWitholdingTaxSetup.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          witholdingTaxSetup: action.payload,
        };
      })
      .addCase(getWitholdingTaxSetup.rejected, (state, action) => {
        return {
          ...state,

          error: action.payload,
        };
      });

    builder
      .addCase(getWitholdingTaxSetupId.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(getWitholdingTaxSetupId.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          witholdingTaxSetupDetails: action.payload,
        };
      })
      .addCase(getWitholdingTaxSetupId.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });

    builder
      .addCase(getAccountLedgerSetup.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(getAccountLedgerSetup.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          accountLedgerSetup: action.payload,
        };
      })
      .addCase(getAccountLedgerSetup.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });

    // getPaymentRecognitionSetup
    builder
      .addCase(getPaymentRecognitionSetup.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(getPaymentRecognitionSetup.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          paymentRecognitionSetup: action.payload,
        };
      })
      .addCase(getPaymentRecognitionSetup.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });

    builder
      .addCase(getFeeSetup.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(getFeeSetup.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          FeeSetup: action.payload,
        };
      })
      .addCase(getFeeSetup.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });

    builder
      .addCase(getAllEmployees.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(getAllEmployees.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          employees: action.payload,
        };
      })
      .addCase(getAllEmployees.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
    builder
      .addCase(createPayment.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(createPayment.fulfilled, (state) => {
        return {
          ...state,
          isLoading: false,
        };
      })
      .addCase(createPayment.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
    builder
      .addCase(updatePayment.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(updatePayment.fulfilled, (state) => {
        return {
          ...state,
          isLoading: false,
        };
      })
      .addCase(updatePayment.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
    builder
      .addCase(createPaymentType.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(createPaymentType.fulfilled, (state) => {
        return {
          ...state,
          isLoading: false,
        };
      })
      .addCase(createPaymentType.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
    builder
      .addCase(updatePaymentType.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(updatePaymentType.fulfilled, (state) => {
        return {
          ...state,
          isLoading: false,
        };
      })
      .addCase(updatePaymentType.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
    builder
      .addCase(editNarration.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(editNarration.fulfilled, (state) => {
        return {
          ...state,
          isLoading: false,
        };
      })
      .addCase(editNarration.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
    builder
      .addCase(getAllDepts.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(getAllDepts.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          depts: action.payload,
        };
      })
      .addCase(getAllDepts.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
  },
});

export const { viewSetup } = PaymentSetupSlice.actions;

export default PaymentSetupSlice.reducer;
